import { useState, Fragment } from 'react';
import { Card, Typography, TextField, Dialog, Grow, Alert, Grid } from '@mui/material';

import { AdminApi } from 'api';
import { ButtonComponent } from 'components/ui';

const domainRegExp = new RegExp(/^(?!-)([A-Za-z0-9-]{1,63}\.)+[A-Za-z]{2,}$/);

export const AddDomain = ({ open, onCloseModal, updateDomais = console.log }) => {
  const [domain, setDomain] = useState('');
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');

  const onChangeDomain = (e) => setDomain(e.target.value);

  const disabled = !domainRegExp.test(domain) || loading;

  const onCloseModal_ = (_, reason) => {
    if (reason === 'backdropClick' && loading) return;
    onCloseModal('');
  };

  const onCreate = () => {
    setLoading(true);
    AdminApi.addBlackListDomain({ domain })
      .then(() => {
        updateDomais();
        onCloseModal_();
      })
      .catch(setErrorMessage)
      .finally(() => setLoading(false));
  };

  return (
    <Dialog open={open} onClose={onCloseModal_} aria-labelledby='alert-dialog-title' aria-describedby='alert-dialog-description'>
      <Card sx={{ width: 400, padding: 4, paddingBottom: 5 }}>
        <Typography sx={{ marginBottom: 2 }} variant='h4'>
          Add Domain to the Black List
        </Typography>
        {errorMessage ? (
          <Grow in={!!errorMessage}>
            <Alert severity='error'>{errorMessage}</Alert>
          </Grow>
        ) : (
          <Fragment>
            <Typography sx={{ marginBottom: 4 }} variant='body2' component='p' color='text.secondary'>
              Put domain name (after @)
            </Typography>
            <Grid container direction='column' mb='20px'>
              <Typography mb='10px' sx={{ lineHeight: '15px' }} variant='body2' color='text.secondary'>
                Domain Name
              </Typography>
              <TextField
                InputProps={{ sx: { fontSize: 14 } }}
                onChange={onChangeDomain}
                value={domain}
                placeholder='Domain Name'
                name='name'
                error={domain && !domainRegExp.test(domain)}
                variant='outlined'
                fullWidth
                disabled={loading}
              />
            </Grid>
            <Grid container justifyContent='space-between' sx={{ marginTop: 4 }}>
              <ButtonComponent color='primary' variant='outlined' disabled={loading} onClick={onCloseModal_} text='CANCEL' width={120} marginRight='20px' />
              <ButtonComponent width='calc(100% - 140px)' disabled={disabled} onClick={onCreate} text='Add' />
            </Grid>
          </Fragment>
        )}
      </Card>
    </Dialog>
  );
};
